import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExpressPayRoutingModule } from './express-pay-routing.module';
import { ExpressPayComponent } from './express-pay/express-pay.component';
import { ExpressPayInfo } from './express-pay/express-pay.component';

import { ExpressPayService } from './express-pay.service';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import {
  MatButtonModule,
  MatIconModule,
  MatInputModule,
  MatDialogModule,
  MatProgressSpinnerModule, MatTooltipModule
} from '@angular/material';
import { CashOnlyDialog } from '../../dashboard/dashboard/dashboard.component';
import { TextMaskModule } from 'angular2-text-mask';

@NgModule({
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  imports: [
    CommonModule,
    ExpressPayRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    TextMaskModule
  ],
  providers: [ExpressPayService],
  entryComponents: [CashOnlyDialog],
  declarations: [ExpressPayComponent, ExpressPayInfo],
  bootstrap: [ExpressPayInfo]
})
export class ExpressPayModule { }



// WEBPACK FOOTER //
// ./src/app/payment/express-pay/express-pay.module.ts